import Marquee from "react-fast-marquee";

const WORDS = [
  "QA / QC", "Material Inspection", "SOP & Methodology", "NABL Coordination",
  "BOQ Specifications", "Standards Guidance", "Training",
];

export default function MarqueeStrip() {
  return (
    <section className="relative z-10 border-y border-white/10 bg-secondary/40 py-8 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading font-bold text-4xl md:text-6xl tracking-tighter text-stroke px-8">
              {w}
            </span>
            <span className="text-primary text-3xl">&bull;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
